module.exports = __webpack_public_path__ + "img/bilili.97a125a8.png";